export default function removeSmartQuotes(string){
 return string.replace(/[“”]/g, '"').replace(/[‘’]/g, "'")
}